export default `float s=3., e;
    s*=e=3./min(dot(p,p),20.);
    p=abs(p)*e;
    escape = 0.;
    for(int i=0;i++<12;){
      p=vec3(1.0,4.0,2.0)-abs(p-vec3(2.0,4.0,2.0)),
      s*=e=8./min(dot(p,p),12.),
      p=abs(p)*e;
      escape += exp(-0.2*dot(p,p));
    }
    return min(length(p.xz)-.1,p.y)/s;
  }`